module.exports = __webpack_public_path__ + "static/media/gryphon-house-storefront.188bb8d5.jpg";